import { Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-date-search',
  templateUrl: './date-search.component.html',
  styleUrls: ['./date-search.component.scss']
})
export class DateSearchComponent implements OnInit {

  str = `
  " Formats de données du Web ; M1 WIC ; S8 ; Manuel ATENCIA ARCAS ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5233 ; CM ; 03/22/2021 ; 08h30 ; 10h00 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/93856883216?pwd=ZVlSSEFtelZzQ0xVbVNHNm1TUmVKZz09 "
  " Formats de données du Web ; M1 WIC ; S8 ; Manuel ATENCIA ARCAS ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5233 ; TD ; 03/22/2021 ; 10h15 ; 11h45 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/93856883216?pwd=ZVlSSEFtelZzQ0xVbVNHNm1TUmVKZz09 "
  " Interface Homme Machine ; M1 WIC ; S8 ; Julie DUGDALE ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5245 ; CM ; 03/23/2021 ; 10h00 ; 12h00 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/95163181509?pwd=a29aNWs1MlFhZnVSeHBGRVYwQk5IUT09 "
  " Programmation web côté client ; M1 WIC ; S8 ; CHEVALLIER ; https://miashs-www.u-ga.fr/~chevallj/ ; TP ; 03/23/2021 ; 14h00 ; 16h00 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/my/chevallj "
  " Informatique décisionnelle ; M1 WIC ; S8 ; Sophie DUPUY-CHESSA ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5234 ; CM ; 03/24/2021 ; 08h30 ; 10h00 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/my/dupuychessa "
  " Informatique décisionnelle ; M1 WIC ; S8 ; Sophie DUPUY-CHESSA ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5234 ; TD ; 03/24/2021 ; 10h15 ; 11h45 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/my/dupuychessa "
  " Interface Homme Machine ; M1 WIC ; S8 ; Julie DUGDALE ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5245 ; TD ; 03/24/2021 ; 15h00 ; 16h30 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/93856929530?pwd=L2t3VUZ5UWZxN29GUmZIWG9KNVpZdz09 "
  " Etudes comportementales ; M1 WIC ; S8 ; Raphaêl LABOISSIERE ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=9468 ; TD ; 03/25/2021 ; 08h30 ; 10h00 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/98475171423?pwd=eFpvV2loYWZOc2FKdkJjVWE2aDFpUT09 "
  " Anglais ; M1 WIC ; S8 ; Sally BROWN ; https://drive.google.com/drive/folders/1MnnR_lGtEn7P8y5Hk5Cle6Zcf0gSWUp5 ; CM ; 03/25/2021 ; 13h00 ; 16h00 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/94725267235?pwd=ajF6dWkzUmpFd2Fob2hlVU9HWTFtQT09 "
  " Gestion de projet ; M1 WIC ; S8 ; Lucas BISOGNIN ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5244 ; CM ; 03/26/2021 ; 13h30 ; 15h30 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/93560342651?pwd=dU1aYVd3bDJvUEdlYXRSL1FiVDlOZz09 "
  " Gestion de projet ; M1 WIC ; S8 ; Lucas BISOGNIN ; https://cours.univ-grenoble-alpes.fr/course/view.php?id=5244 ; CM ; 03/26/2021 ; 15h45 ; 17h45 ; non ; null ; https://univ-grenoble-alpes-fr.zoom.us/j/93560342651?pwd=dU1aYVd3bDJvUEdlYXRSL1FiVDlOZz09 "
  `;

  tab: any = this.parse(this.str);
  name: string = "datesearch";
  ind: number = 0;
  todate: string = "0" + ((new Date().getMonth() + 1)) + '/' + new Date().getDate() + '/' + new Date().getFullYear();

  constructor() { }

  ngOnInit(): void {
  }

  onKey(event: any) { 
    console.log(event.target.value);
    console.log(this.todate);
    setTimeout(() => {
      this.rechercheCours();
     
     }, 5000);
   
  }

  setId(event :any) {
    console.log(event);
    console.log(event.target.id);
    this.ind = event.target.id;
  }

  rechercheCours() {
    let filter, ul, li, i;
    var dt = (<HTMLInputElement>document.getElementById('datepicker'));
    console.log(dt.value);
    if (dt != null) {
      filter = dt.value;
      ul = document.getElementById("edt");
      if (ul != null) {
        li = ul.getElementsByTagName("li");
        for (i = 0; i < li.length; i++) {
          console.log(filter + ":" + this.tab[i].date + ":" + (filter===this.tab[i].date));
          if (filter === this.tab[i].date) {
            console.log("je marche a chaque fois");
            
            li[i].style.display = "";
            console.log(li[i]);
          } else {
            console.log("je marche les autres fois");
            li[i].style.display = "none";
          }
        }
      }
    }
  }

 

  sendInfo(id:number) {
    return [this.tab[id].nom, this.tab[id].filiare,this.tab[id].semestre, this.tab[id].prof, this.tab[id].web, this.tab[id].type, this.tab[id].date,  this.tab[id].heuredeb, this.tab[id].heurefin, this.tab[id].presentiel, this.tab[id].salle, this.tab[id].zoom];
  }


  parse(str: string): COURS[] {

    const L: COURS[] = str.trim().split("\n").map(s => s.trim()).filter(s => s !== "")

      .map(s => s.split(";").map(s => s.slice(1, -1)))

      .map(([n,f,s,p,w,t,d,hd,hf,pr,sa,z]) => ({

        nom: n,

        filiare: f,
        
        semestre:s,

        prof: p,
        
        web: w,
        
        type:t,
         
        date: d,

        heuredeb: hd,

        heurefin: hf,

        presentiel: pr,
        
        salle:sa,
        
        zoom:z,

                 }));

    return L;

  }

}


interface COURS{

  nom: string;

  filiare: string;

  semestre: string;

  prof: string;

  web: string;

  type: string;

  date: string;

  heuredeb: string;
  
  heurefin: string;

  presentiel: string;

  salle: string;

  zoom:string;


}